import { lazy } from '@/service/lazy'

export default [{
  name: 'Comissões',
  path: 'comissoes-comerciais',
  id: 'comissoes-comerciais',
  icon: 'fa fa-user',
  component: lazy('app/default/adm_financeiro/comissao-vendedores/index'),
  meta: { requireAuth: true, rules: ['relatorio_comissao_vendedores'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/comissao-vendedores.js